import Header from './Header';
import Footer from './Footer';


function Ofert(lang) {
    if(lang.lang==="pl"){
        return (
            <div className='App'>
                <Header />
                <br />
                <h1>Oferta</h1>
                <div className='offertgrid'>
                    <h3>OFERTA</h3>
                    <h1>Nasze usługi</h1>
                    <br />
                    <div id='offergrid'>
                        <div className='offer'>
                            <img alt='pricesimg' src='/price1.webp' />
                            <br />
                            <h3>Usługi księgowe pełna obsługa księgowa</h3>
                            <br />
                            <h5>Pełna obsługa księgowa, w tym prowadzenie ksiąg rachunkowych, KRiP, Księgi przychodów oraz doradztwo w zakresie optymalizacji podatków</h5>
                        </div>
                        <div className='offer'>
                            <img alt='pricesimg' src='/price2.webp' />
                            <br />
                            <h3>Doradztwo biznesowe</h3>
                            <br />
                            <h5>Pomoc w opracowywaniu strategii rozwoju, wybory formy prowadzenia działalności, analizy rynku oraz pozyskiwaniu funduszy.</h5>
                        </div>
                        <div className='offer'>
                            <img alt='pricesimg' src='/price3.webp' />
                            <br />
                            <h3>Legalizacja biznesu w Polsce, usługi.</h3>
                            <br />
                            <h5>Wsparcie w procesie zakupu, rejestracji oraz legalizacji działalności gospodarczej w Polsce.</h5>
                        </div>
                        
                    </div>
                    <br />
                </div>
                <Footer />
            </div>
        );
    }
    if(lang.lang==="ua"){
        return (
            <div className='App'>
                <Header />
                <br />
                <h1>НАШІ ПОСЛУГИ</h1>
                <div className='offertgrid'>
                    <br/>
                    <br/>
                    <h1>НАШІ ПОСЛУГИ</h1>
                    <br />
                    <div id='offergrid'>
                        <div className='offer'>
                            <img alt='pricesimg' src='/price1.webp' />
                            <br />
                            <h3>Бухгалтерські послуги повне бухгалтерське обслуговування</h3>
                            <br />
                            <h5>Повне бухгалтерське обслуговування, включаючи ведення бухгалтерського обліку фірм і підприємницької діяльності, консультування з оптимізації податків.</h5>
                        </div>
                        <div className='offer'>
                            <img alt='pricesimg' src='/price2.webp' />
                            <br />
                            <h3>Бізнес-Консалтинг</h3>
                            <br />
                            <h5>Допомога у розробці стратегії розвитку, аналізі ринку та зборі коштів.</h5>
                        </div>
                        <div className='offer'>
                            <img alt='pricesimg' src='/price3.webp' />
                            <br />
                            <h3>Легалізація бізнесу та перебування в Польщі</h3>
                            <br />
                            <h5>Підтримка в процесі покупки, реєстрації, легалізації підприємницької діяльності в Польщі. Отримання дозволів на перебування часове, постійне, резидента ЄС та оримання громадянства </h5>
                        </div>
                        
                    </div>
                    <br />
                </div>
                <Footer />
            </div>
        );
    }
    
}

export default Ofert;